import { ExpiryStatus } from '../domain/ExpiryStatus';

export const formatLocalDateString = (date: string): string => {
	const isoDate = new Date(date);
	return formatDate(isoDate);
};

export const formatUTCDateString = (date: string): string => {
	const isoDateOnly = date.split("T")[0];
	return formatDate(new Date(isoDateOnly));
};

export const formatPreviousDayWithDayAndMonth = (date: string): string => {
	const isoDate = new Date(date);
	isoDate.setDate(isoDate.getDate() - 1);
	return isoDate
		.toLocaleDateString('en-GB', { month: '2-digit', day: '2-digit' })
		.replace(new RegExp('/', 'g'), '.');
};

export const formatDate = (isoDate: Date): string => {
	return isoDate.toLocaleDateString('en-GB')
		.replace(new RegExp('/', 'g'), '.');
};

export const formatPreviousDayExpirationDate = (date: string): string => {
	const isoDate = new Date(date);
	isoDate.setDate(isoDate.getDate() - 1);
	return isoDate.toLocaleDateString('en-GB')
		.replace(new RegExp('/', 'g'), '.');
};

export const calculateExpirationStatus = (date: string): ExpiryStatus => {
	const expirationDate = new Date(date);
	const currentDate = new Date();

	const hoursToExpiration = (expirationDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60);

	if (hoursToExpiration > 0 && hoursToExpiration < 24) {
		return ExpiryStatus.TODAY;
	} else if (hoursToExpiration >= 24 && hoursToExpiration < 48) {
		return ExpiryStatus.TOMORROW;
	} else if (hoursToExpiration >= 48) {
		return ExpiryStatus.LATER;
	} else {
		return ExpiryStatus.EXPIRED;
	}
};
